import React from 'react'
import Head from 'next/head'
import { theme } from '@superhi/design'

import { Wrapper } from './styles'

const OPTIONS = [
  'seo=false',
  'videoFoam=true',
  'endVideoBehavior=loop',
  'autoPlay=true',
  'controlsVisibleOnLoad=false',
  // "fitStrategy=contain",
  'playbar=false',
  'settingsControl=false',
  'volumeControl=false',
  'muted=true',
  'volumeControl=false',
  'playButton=false',
  'fullscreenButton=false',
  'smallPlayButton=false',
  'copyLinkAndThumbnailEnabled=false',
]

const OPTIONS_STRING = OPTIONS.join('&')

type Props = {
  className?: string
  id: string
  title: string
  backgroundColor?: keyof typeof theme.colors
}

const WistiaVideoEmbed: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  id,
  title,
  backgroundColor,
}) => (
  <>
    <Wrapper className={className} $backgroundColor={backgroundColor}>
      <iframe
        src={`https://fast.wistia.net/embed/iframe/${id}?${OPTIONS_STRING}`}
        title={title}
        allow="autoplay; fullscreen"
        frameBorder="0"
        scrolling="no"
        className="wistia_embed"
        name="wistia_embed"
        allowFullScreen
        width="100%"
        height="100%"
      />
    </Wrapper>

    <Head>
      <script id="wistiaEmbed" src="https://fast.wistia.net/assets/external/E-v1.js" async />
    </Head>
  </>
)

export default WistiaVideoEmbed
